import React from 'react';
import Reveal from '../lib/Reveal.jsx';

const GROUPS = [
  { label: 'Financial institutions', items: [
    { name: 'Bank of Israel', work: 'Financial infrastructure advisory' },
    { name: 'National Payment Switch', work: 'Strategic IT advisory' },
    { name: 'Intra Bank Clearing', work: 'Core modernization gap analysis' },
    { name: 'FIBI', work: 'Modernization strategy' },
    { name: 'BHP IL', work: 'Applied AI practice in core modernization' },
    { name: 'Bit', work: 'Agentic SDLC review' },
    { name: 'Union Bank', work: 'Strategic core transformation and modernization' },
  ]},
  { label: 'Fintechs & ventures', items: [
    { name: '40Seas', work: 'Platform & product advisory' },
    { name: 'Be The Bank', work: 'Banking & fintech advisory' },
    { name: 'WePay Digital Wallet', work: 'CEO — digital wallet leadership' },
    { name: 'Global Remit', work: 'Executive Director — remittance fintech' },
    { name: 'Kualys Audiology', work: 'CEO — startup leadership' },
    { name: '10x Banking', work: 'Product realization, Mastercard integration' },
  ]},
  { label: 'Enterprise', items: [
    { name: 'Amdocs', work: 'AI transformation · agentic SDLC · context manager' },
    { name: 'KPMG', work: 'Strategic advisory · FRM · M&A · emerging technologies' },
  ]},
];

export default function Engagements({ tweaks }) {
  return (
    <section id="work" className="section">
      <div className="container">
        <div className="grid12" style={{ marginBottom: 64, alignItems: 'end' }}>
          <Reveal style={{ gridColumn: 'span 6' }}>
            <div className="section-marker" style={{ marginBottom: 24 }}>
              {tweaks.sectionDividers === 'numbered' ? '03 / Engagements' : 'Engagements'}
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, letterSpacing: '-0.025em', margin: 0, textWrap: 'balance' }}>
              Selected client &amp; <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>collaboration</span> experience.
            </h2>
          </Reveal>
          <Reveal style={{ gridColumn: '8 / span 5' }}>
            <p style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--ink-60)', margin: 0, maxWidth: '40ch' }}>
              Founder and Jishu-related experience across financial services, technology, academia, and enterprise transformation. Logos are not used without explicit permission; named here as engagements only.
            </p>
          </Reveal>
        </div>

        <Reveal stagger className="mobile-collapse-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}>
          {GROUPS.map((g) => (
            <div key={g.label} style={{ borderTop: '1px solid var(--ink-24)', paddingTop: 20 }}>
              <div className="mono-label" style={{ marginBottom: 16, color: 'var(--ink)' }}>— {g.label}</div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {g.items.map((it, i) => (
                  <div key={i} style={{ padding: '14px 0', borderTop: i === 0 ? 'none' : '1px solid var(--ink-12)' }}>
                    <div style={{ fontFamily: 'var(--font-display)', fontSize: 19, color: 'var(--ink)', letterSpacing: '-0.005em', lineHeight: 1.25 }}>{it.name}</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-60)', marginTop: 4, lineHeight: 1.4 }}>{it.work}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
